"use strict";
// Copyright (c) StrangeBee 2023
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class CustomTagController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            edit: 'v1/tag/:objectId',
            delete: 'v1/tag/:objectId',
        };
    }
    create({}) {
        throw new Error("Can't create custom tags!");
    }
}
exports.default = CustomTagController;
